import React from "react";

interface DropdownInputProps<T extends React.ReactNode> {
  value: T | null;
  onChange: (value: T) => void;
  options: T[];
  // Optional display labels keyed by the stringified option value. When
  // present, each option renders `optionLabels[option] ?? option` while the
  // emitted value stays the raw option (an enum can store keys but show
  // labels — same contract as StatusDropdown / PortalledEnumDropdown).
  optionLabels?: Record<string, string> | null;
  placeholder?: string;
  className?: string;
  inputRef?: React.RefObject<HTMLSelectElement>;
}

function DropdownInput<T extends React.ReactNode>({
  value,
  onChange,
  options,
  optionLabels,
  placeholder = "Select an option",
  className = "",
  inputRef,
}: DropdownInputProps<T>) {
  return (
    <select
      ref={inputRef}
      value={value ? String(value) : ""}
      onChange={(e) => onChange(e.target.value as T)}
      className={`w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-[var(--fp-ink-3)] focus:border-[var(--fp-ink-3)] ${className}`}
    >
      <option value="">{placeholder}</option>
      {options.map((option, index) => (
        <option key={index} value={String(option)}>
          {optionLabels?.[String(option)] ?? option}
        </option>
      ))}
    </select>
  );
}

export default DropdownInput;
